var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.param.type == "role_id" ? _c("div", [_c("el-input", {
    attrs: {
      placeholder: _vm.param.placeholder
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "server_name" ? _c("div", [_c("el-input", {
    attrs: {
      placeholder: _vm.param.placeholder
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "phone" ? _c("div", [_c("el-input", {
    attrs: {
      placeholder: _vm.param.placeholder
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "input" ? _c("div", [_c("el-input", {
    attrs: {
      placeholder: _vm.param.placeholder
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "textarea" ? _c("div", [_c("el-input", {
    attrs: {
      type: "textarea",
      placeholder: _vm.param.placeholder
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "select" ? _c("div", [_c("el-select", {
    attrs: {
      placeholder: _vm.param.placeholder
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }, _vm._l(_vm.param.option, function (val, key) {
    return _c("el-option", {
      key: key,
      attrs: {
        label: val.label,
        value: val.label
      }
    });
  }), 1)], 1) : _vm._e(), _vm.param.type == "switch" ? _c("div", [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "checkbox" ? _c("div", _vm._l(_vm.param.option, function (val, key) {
    return _c("span", {
      key: key,
      staticStyle: {
        "margin-right": "15px"
      },
      attrs: {
        label: val.label
      }
    }, [_c("el-checkbox", {
      model: {
        value: val.isChecked,
        callback: function callback($$v) {
          _vm.$set(val, "isChecked", $$v);
        },
        expression: "val.isChecked"
      }
    }, [_vm._v(_vm._s(val.label))])], 1);
  }), 0) : _vm._e(), _vm.param.type == "radio" ? _c("div", [_c("el-radio-group", {
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }, _vm._l(_vm.param.option, function (val, key) {
    return _c("el-radio", {
      key: key,
      attrs: {
        label: val.label
      }
    });
  }), 1)], 1) : _vm._e(), _vm.param.type == "datePicker" ? _c("div", [_c("el-date-picker", {
    attrs: {
      type: "date",
      placeholder: "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "uploadImage" ? _c("div", [_c("upload-image", {
    attrs: {
      fileSize: 512,
      maxWH: 1080
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e(), _vm.param.type == "file" ? _c("div", [_c("upload-image", {
    attrs: {
      fileSize: 512,
      maxWH: 1080
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };